import { useState, useEffect } from 'react';
import { useOnboarding } from '../context/OnboardingContext';

export function useChoiceSelection(element) {
    const {
        globalAnswers,
        getCurrentScreen,
        updateFormData,
        updateGlobalAnswer,
        goToNextScreen,
    } = useOnboarding();

    const currentScreen = getCurrentScreen();
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        const globalAnswer = currentScreen?.name ? globalAnswers.get(currentScreen.name) : null;
        if (globalAnswer?.value && globalAnswer?.elementName === element.name) {
            setSelectedValue(globalAnswer.value);
        } else {
            setSelectedValue(null);
        }
    }, [element.name, globalAnswers, currentScreen]);

    const handleSelect = (option) => {
        setSelectedValue(option.value);
        updateFormData(element.name, option.value);

        if (currentScreen?.name) {
            updateGlobalAnswer(currentScreen.name, {
                text: option.text || option.value,
                value: option.value,
                elementName: element.name,
            });
        }

        setTimeout(() => {
            goToNextScreen(true);
        }, 300);
    };

    return { selectedValue, handleSelect };
}
